import { FAULU_LOAN_CALCULATOR_FORM_SET_VALUE } from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { fauluLoanCalculatorFormRules } from "./fauluLoanCalculator";


export const fauluLoanCalculatorRules = (store, next, action) => {
     if (action.type.startsWith(FAULU_LOAN_CALCULATOR_FORM_SET_VALUE)) {
        return fauluLoanCalculatorFormRules(store, next, action);
    }
}